export default class Step3Validator {
    constructor(consents, inpostData, discountComponent) {

        this.consents = consents;

        this.aclariAgreement = $('#basketorder-policies-aimor-1');
        this.userAgreement = $('#accountControllAgreement');
        this.inpostRegulations = $('#basketorder-inpost-chk_inpost_accept-1');
        this.discountAgreement = $('#basketorder-policies-discount');
        this.sizeVariationAgreement = $('#basketorder-policies-size-variation');

        this.accountCreate = $('#basketorder-create_account-1');

        this.inpostData = inpostData;
        this.discountComponent = discountComponent;
    }

    isSizeVariationAgreement() {
        let result = this.sizeVariationAgreement.is(":visible") ? this.sizeVariationAgreement.prop('checked') === true : true;

        this.markCheckbox(this.sizeVariationAgreement, result);
        return result;
    }

    isAclariAgreementChecked() {
        let result = this.aclariAgreement.is(":visible") ? this.aclariAgreement.prop('checked') === true : true;

        this.markCheckbox(this.aclariAgreement, result);
        return result;
    }

    isDiscountAgreementChecked() {
        let result = this.discountAgreement.is(":visible") ? this.discountAgreement.prop('checked') === true : true;

        this.markCheckbox(this.discountAgreement, result);
        return result;
    }

    isUserAgreementChecked() {
        let result = this.userAgreement.is(":visible") || this.accountCreate.is(":checked") ? this.userAgreement.prop('checked') === true : true;

        this.markCheckbox(this.userAgreement, result);
        return result;
    }

    isRegulationsAccepted() {
        let result = this.inpostRegulations.is(":visible") ? this.inpostRegulations.prop('checked') === true : true;

        this.markCheckbox(this.inpostRegulations, result);
        return result;
    }

    markCheckbox(currentCheckbox, isOk) {
        let label = currentCheckbox.parent().find('label');
        label.css('color', isOk ? 'inherit' : '#ff0000');
    }

    validate() {
        const agreement = this.isAclariAgreementChecked(),
            userAgreement = this.isUserAgreementChecked(),
            sizeVariationAgreement = this.isSizeVariationAgreement(),
            discountAgreement = this.isDiscountAgreementChecked();

        let inpostAgreement = true;
        if (Object.keys(this.inpostData.getSelectedPoint()).length > 0) {
            inpostAgreement = this.isRegulationsAccepted()
        }

        return agreement && userAgreement && inpostAgreement && discountAgreement && sizeVariationAgreement;
    }
}
